import FunctionalButton from "components/layout/FunctionalButton";

import { ReactComponent as StairIcon } from "assets/svgs/robot/modes/Stair.svg";


const StairsButton = ({ onClick }) => (
    <FunctionalButton
        icon={<StairIcon className="h-9 w-9 shrink-0 text-white" />}
        className="control-button-type1 bg-black100"
        onClick={onClick}
    />
);

export default StairsButton